import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AIONZ_TOOLTIP_DATA } from '@aionzdev/design-system';
import { ItemSuppliersSummary } from '../../../interfaces/item-suppliers-summary';

/** Tooltip do chip de fornecedores da tabela de itens: quem cota o produto e de onde veio. */
@Component({
  selector: 'aionz-item-suppliers-tooltip',
  imports: [MatIconModule],
  templateUrl: './item-suppliers-tooltip.component.html',
  styleUrl: './item-suppliers-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemSuppliersTooltipComponent {
  protected readonly data = inject(AIONZ_TOOLTIP_DATA) as ItemSuppliersSummary;

  protected readonly pendingCount = computed(
    () => this.data.suppliers.filter(s => s.pendingApproval).length
  );

  protected readonly summary = computed(() => {
    const total = this.data.suppliers.length;
    const base = `${total} ${total === 1 ? 'fornecedor' : 'fornecedores'}`;
    const pending = this.pendingCount();
    if (!pending) return base;
    return `${base} · ${pending} ${pending === 1 ? 'sugestão pendente' : 'sugestões pendentes'}`;
  });
}
